import { type Dispatch, type SetStateAction, useCallback } from 'react'

import {
  type FilterValue,
  type DateRange,
} from '../components/multi-select/filterTypeConfig'

export const useDateTime = (
  selectedFilters: FilterValue[],
  setSelectedFilters: Dispatch<SetStateAction<FilterValue[]>>
) => {
  const updateDateTimeFilter = useCallback(
    (
      filterKey: 'start_at' | 'end_at',
      fieldKey: 'startDate' | 'startTime' | 'endDate' | 'endTime',
      value: Date | string | null
    ) => {
      setSelectedFilters((prev: FilterValue[]) => {
        const existingFilter = prev.find((f) => f.key === filterKey)
        const defaultValues: DateRange = {
          startDate: null,
          startTime: '',
          endDate: null,
          endTime: '',
        }

        const updatedDates: DateRange = {
          ...((existingFilter?.value as DateRange) || defaultValues),
          [fieldKey]:
            value instanceof Date ? value.toISOString().split('T')[0] : value,
        }

        return existingFilter
          ? prev.map((f) =>
              f.key === filterKey ? { key: filterKey, value: updatedDates } : f
            )
          : [...prev, { key: filterKey, value: updatedDates }]
      })
    },
    [setSelectedFilters]
  )

  const getDateRange = useCallback(
    (filterKey: 'start_at' | 'end_at'): DateRange => {
      return (
        (selectedFilters.find((f) => f.key === filterKey)
          ?.value as DateRange) || {
          startDate: null,
          startTime: '',
          endDate: null,
          endTime: '',
        }
      )
    },
    [selectedFilters]
  )

  return {
    handleDateChange: (key: 'startDate' | 'endDate', date: string | null) =>
      updateDateTimeFilter(
        key === 'startDate' ? 'start_at' : 'end_at',
        key,
        date
      ),

    handleTimeChange: (key: 'startTime' | 'endTime', time: string) =>
      updateDateTimeFilter(
        key === 'startTime' ? 'start_at' : 'end_at',
        key,
        time
      ),

    getDateRange,
  }
}
